import { ObjectMapper } from './ObjectMapper';
import { resolveDownloadSvg } from '@/utils/resolveBackendUrl';

export class ProductInCategoryMapper {
    private static propertiesProductInCategory: Array<keyof ProductInCategory> = ['id', 'name', 'index', 'previewPath'];

    static getProductFromData(productData: ProductInCategoryApi): ProductInCategory {
        ProductInCategoryMapper.checkProductData(productData);
        const { id, name, index, previewPath, labelList } = productData;

        const product: ProductInCategory = {
            id: id || '',
            name: name || '',
            index: index || 0,
            previewPath: resolveDownloadSvg(previewPath) || ''
        };

        const translatedName: string | undefined = ObjectMapper.getTranslatedName(labelList);
        product.name = translatedName || product.name;

        return product;
    }

    private static checkProductData(productData: ProductInCategoryApi): void {
        ProductInCategoryMapper.propertiesProductInCategory.forEach((prop) => {
            if (productData[prop] == null) {
                console.error(`Property ${prop} is missing or undefined in this product: ${productData.id}.`);
            }
        });
    }
}
